// extracted by mini-css-extract-plugin
module.exports = {"underscore":"Heading_underscore__6nQZ8"};